import React from 'react';

import { TopPreview } from '@/pages/Portfolio/';

export const PortfolioPreview = (): React.ReactElement => <TopPreview presentation admin />;
